import { useState, useEffect, useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useUserStatus } from '../../context/UserStatusContext';
import { getUserProfile } from '../../services/apiService';
import CoreProfileModal from './CoreProfileModal';
import ModuleEmptyState from './ModuleEmptyState';
import { formatGender, formatDate } from '../../utils/formatUtils';
import styles from './DashboardModules.module.css';

const CoreProfileModule = ({ isRecommended }) => {
  const { refreshUserStatus } = useUserStatus();
  const { getAccessTokenSilently } = useAuth0();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchProfile = useCallback(async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      const data = await getUserProfile(accessToken);
      setProfileData(data);
    } catch (error) {
      console.error('Failed to fetch core profile:', error);
    } finally {
      setIsLoading(false);
    }
  }, [getAccessTokenSilently]);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  const handleSave = () => {
    fetchProfile();
    refreshUserStatus();
  };

  const isComplete = profileData?.firstName && profileData?.lastName;

  return (
    <>
      <div
        className={`${styles.moduleCard} ${isComplete ? styles.completed : ''} ${isRecommended ? styles.recommended : ''}`}
      >
        <div className={styles.moduleHeader}>
          <h5>Core Profile</h5>
          {isComplete ? (
            <span className={`${styles.statusTag} ${styles.complete}`}>
              Complete
            </span>
          ) : (
            <span className={`${styles.statusTag} ${styles.todo}`}>To-Do</span>
          )}
        </div>
        <div className={styles.moduleContent}>
          {isLoading ? (
            <p>Loading profile...</p>
          ) : isComplete ? (
            <>
              <div className={styles.infoGrid}>
                <div className={styles.infoItem}>
                  <label>First Name</label>
                  <span>{profileData.firstName}</span>
                </div>
                <div className={styles.infoItem}>
                  <label>Last Name</label>
                  <span>{profileData.lastName}</span>
                </div>
                <div className={styles.infoItem}>
                  <label>Gender</label>
                  <span>{formatGender(profileData.gender)}</span>
                </div>
                <div className={styles.infoItem}>
                  <label>Date of Birth</label>
                  <span>{formatDate(profileData.dateOfBirth)}</span>
                </div>
              </div>
              <button
                onClick={() => setIsModalOpen(true)}
                className={`action-button secondary ${styles.editButton}`}
              >
                Edit Profile
              </button>
            </>
          ) : (
            <ModuleEmptyState
              icon="fa-user-edit"
              text="Your Passport is anonymous. Add your name and basic info to personalize it."
              buttonText="Add Profile Info"
              onButtonClick={() => setIsModalOpen(true)}
            />
          )}
        </div>
      </div>
      {isModalOpen && (
        <CoreProfileModal
          userProfile={profileData}
          onClose={() => setIsModalOpen(false)}
          onSave={handleSave}
        />
      )}
    </>
  );
};

export default CoreProfileModule;
